var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "AuthCard",
        { staticClass: "text-center pt-10", attrs: { title: _vm.title } },
        [
          _c("p", { staticClass: "mb-2" }, [
            _vm._v(" " + _vm._s(_vm.message) + " "),
          ]),
          _c("AuthFormLink", {
            attrs: { text: "Sign out" },
            on: { click: _vm.signOut },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }